import React from 'react'
import "antd/dist/antd.css";
import { Row, Col } from "antd";


export default function HeaderDetails(props) {
    const {icon,designation,name,mobileNumber,mailId}=props
  return (
    <Row 
    style={{display:"flex",textAlign:"center",width:"100%"}}
    >
    <Col >
    <img src={"/placeholder.png"} 
        style={{
          height:"47.5px",
          width:"49.7px"
          }}/>
    </Col>
        <Col style={{textAlign:"center",justifyContent:"center",
        paddingLeft:10,marginTop:"-5px"
        }}>
         
            <Row style={{color:"#757575",fontSize:"12px",fontWeight:"400px"}}>{designation}</Row> 
            <Row style={{color:"#000000",fontSize:"16px",fontWeight:"500px"}}>{name}</Row>
            <Row style={{color:"#8C8C8C",fontSize:"14px",fontWeight:"400px"}}>{mobileNumber}</Row>
            <Row style={{color:"#8C8C8C",fontSize:"14px",fontWeight:"400px"}}>{mailId}</Row>
          
        </Col>
    </Row>
  )
}
